import React from "react"
import {useTranslation} from "react-i18next"

import apolloImage from "../../../../../assets/apollo.png"
import logoIcon from "../../../../../assets/logoIcon.svg"
import {TColumnMeta} from "../../../../../components/Table/utils/shared.ts"
import {ADraftedProspectSources} from "../../../../../services/types.generated.ts"
import {TAllColumns, TCommonRow} from "../types.ts"
import {tableLoadingIndicator} from "./common.tsx"

export const useSourceColumn = <TColumns extends TAllColumns, TRow extends TCommonRow>(): TColumnMeta<
  TColumns,
  TRow
> => {
  const {t} = useTranslation()

  return React.useMemo(
    () => ({
      column: "source" as TColumns,
      headerCellClassName: "!bg-cr-blue-super-light",
      HeaderCellValue: () => t("Leads_EditingFlyout_Source"),
      CellValue: ({row}) => {
        if (row.id === "loading") {
          return tableLoadingIndicator
        }

        if (row.source === ADraftedProspectSources.Apollo) {
          return <img src={apolloImage} className={"h-6 w-6"} alt={"Apollo.io"} title={"Apollo.io"} />
        }

        if (row.source === ADraftedProspectSources.Local) {
          return <img src={logoIcon} className={"h-6 w-6"} alt={"CloseRocket"} title={"CloseRocket"} />
        }

        return null
      },
    }),
    [t]
  )
}
